import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import store from './store'
import router from './router'
import Apps from '@/config/index'

Vue.config.productionTip = false
Vue.prototype.$apps = Apps

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
